import { useNavigate } from 'react-router';
import { useTranslations } from '@/i18n/use-translations';
import { useEventStore } from '@/state/stores/use-event-store';
import { SettingsOutlined, VideocamOutlined } from '@mui/icons-material';
import { Chip, IconButton, Stack, Typography } from '@mui/material';
import Widget from '@/components/common/widget.tsx';

export default function Spaces({ openSettings }: { openSettings: () => void }) {
  const t = useTranslations();
  const navigate = useNavigate();
  const event = useEventStore((s) => s.event);

  if (!event) return null;

  return (
    <Widget
      data-testid="event-spaces"
      title={`${event.spaces?.length ?? 0} ${t('common.spaces')}`}
      iconButtons={[
        {
          icon: <SettingsOutlined fontSize="small" />,
          onClick: openSettings,
          testId: 'event-spaces-settings-button',
        },
      ]}
    >
      {event.spaces?.map((space, index) => (
        <Stack
          key={space.id}
          data-testid={`space-${index}`}
          direction="row"
          gap={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack>
            <Typography variant="body2">{space.name}</Typography>
            <Typography variant="body2" color="text.secondary">
              {space.type}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={0.5} alignItems="center">
            {space.playerSetupEnabled ? (
              <Chip size="small" label={t('event.detail.dashboard.spaces.playerSetupEnabled')} />
            ) : null}
            <IconButton
              size="small"
              color="info"
              aria-label={t('event.detail.dashboard.spaces.playerSetup')}
              onClick={() => navigate(`/event/${event.id}/space/${space.id}`)}
            >
              <VideocamOutlined color="info" />
            </IconButton>
          </Stack>
        </Stack>
      ))}
    </Widget>
  );
}
